export function ChromeExtensionBanner() {
  return null;
}
